import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) {}

  private checkAuth(state: RouterStateSnapshot): boolean | UrlTree {
    const token = localStorage.getItem('accessToken');

    if (token) {
      return true;
    }

    /** Link-share UUID under reviews/shared path uses the public `/shared-link/:token` route (no login). */
    const sharedLinkMatch = state.url.match(
      /^\/main\/home\/(?:reviews|shared)\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\?|#|$)/i
    );
    if (sharedLinkMatch) {
      return this.router.createUrlTree(['/shared-link', sharedLinkMatch[1]]);
    }

    // Save the attempted URL for post-login redirect
    localStorage.setItem('returnUrl', state.url);
    return this.router.createUrlTree(['/auth/login'], { queryParams: { m: 'MQ==' } });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAuth(state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkAuth(state);
  }
}
